<template lang="html">
	<div id="page__documents-toolbar" class="toolbar-search__container">
		<div class="toolbar-search">
			<z-select v-model="filter.status" light v-on:input="onFilter">
				<option value="" selected>Статус (все)</option>
				<option value="actual">Актуальные</option>
				<option value="deleted">Удаленные</option>
			</z-select>
			
			<input class="toolbar-search__input" id="toolbar-search__input" type="text" placeholder="Поиск..." v-model="filter.search" v-on:keyup.enter="onFilter"/>
			<z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset" v-if="filter.search && filter.search.length || hasCustomFilter"></z-icon-button>
			<z-icon-button v-bind:icon="['fa', 'gear']" rounded v-on:click="toggleFilter" primary-light ></z-icon-button>
		</div>
		<div class="dropdown md-elevation-2" v-if="filterSettings" v-click-outside="hideFilterSettings">
			<div class="search-md-menu-container">
				<div class="md-layout filter-container">
					<div class="center-layout md-layout-item md-size-20"> <label> Дата создания </label> </div>
                    <div class="center-layout md-layout-item with-pr center-layout md-size-40">
                        <z-date v-model="customFilter.date_from" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата от"></z-date>
                    </div>
                    <div class="center-layout with-pr center-layout md-size-40 md-layout-item">
                        <z-date v-model="customFilter.date_to" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата до"></z-date>
                    </div>

					<div class="center-layout md-layout-item md-size-20"> <label> Дата отправки email </label> </div>
                    <div class="center-layout md-layout-item with-pr center-layout md-size-40">
                        <z-date v-model="customFilter.email_date_from" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата от"></z-date>
                    </div>
                    <div class="center-layout with-pr center-layout md-size-40 md-layout-item">
                        <z-date v-model="customFilter.email_date_to" no-margin v-bind:return-string="false" format="DD.MM.YYYY" type="date" placeholder="Дата до"></z-date>
                    </div>
					
					<div class="md-layout-item md-size-100">
          				<div class="md-layout">
							<div class="md-layout-item md-size-20 center-layout">
								<label> Статус отправки </label>
							</div>
							<div class="md-layout-item md-size-25 with-pr">
								<z-select v-model="customFilter.email_status" name="email_status" id="email-status">
									<option value="" selected>Любой</option>
									<option value="sent">Доставлено</option>
									<option value="not_sent">Не доставлено</option>
								</z-select>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-size-100">
          				<div class="md-layout">
							<div class="md-layout-item md-size-20 center-layout">
								<label> Тип документа </label>
							</div>
							<div class="md-layout-item md-size-25 with-pr">
								<z-select v-model="customFilter.type" name="type" id="type">
									<option value="">Любой</option>
									<option value="bill">Счёт</option>
									<option value="invoice_a4">Счёт фактура</option>
									<option value="assignment">Поручение экспедитору</option>
									<option value="receipt">Экспедиторская расписка</option>
									<option value="act_a4">Акт</option>
									<option value="stock_note">Складская записка</option>
									<option value="route_list">Маршрутный лист</option>
								</z-select>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-size-100">
          				<div class="md-layout">
							<div class="md-layout-item md-size-20 center-layout">
								<label> НДС </label>
							</div>
							<div class="md-layout-item md-size-25 with-pr">
								<z-select v-model="customFilter.nds" name="nds" id="nds">
									<option value="">Любой</option>
									<option value="1">С НДС</option>
									<option value="0">Без НДС</option>
								</z-select>
							</div>
						</div>
					</div>
					<div class="md-layout-item md-size-100 md-alignment-bottom-right dropdown-button-container">
						<z-button class="md-dense md-primary small" fit-content v-on:click="onCustomFilter">Применить</z-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import ZSelect from '@/components/ZSelect';
	import ClickOutside from 'vue-click-outside';
	import ZDate from '@/components/ZDate';
	import ZIconButton from '@/components/ZIconButton.vue';
	import ZButton from '@/components/ZButton.vue';
	export default {
		components: { ZSelect, ZDate, ZIconButton, ZButton },
		directives: { ClickOutside },
		data() {
			return {
				filterSettings: false,
				filter: {
					search:  null,
					status:  null,
					number:  null,
					deal_id: null
				},
				filterDefault: {
					search:  null,
					status:  null,
					number:  null,
					deal_id: null
				},
				customFilter: {
					date_from: null,
					date_to: null,
					email_date_from: null,
					email_date_to: null,
					nds: null,
					type: '',
					email_status: '',
				},
				customFilterDefault: {
					date_from: null,
					date_to: null,
					email_date_from: null,
					email_date_to: null,
					nds: null,
					type: '',
					email_status: '',
				},
				deals: [],
			}
		},
		created() {
			this.resolveQueryFilter();
			this.$root.$emit('refresh-table', 'documents');
		},
		computed: {
			hasCustomFilter() {
				return (this.$route.query && this.$route.query.custom_filter);
			}
		},
		watch: {
			'filter.search'(val) {
				const search = val;
				setTimeout(() => {
					if (!this.filter.search || !this.filter.search.length) return this.onReset()
					if (this.filter.search == search) this.onFilter()
				}, 1000)
			}
		},
		methods: { 
			/**
             * Подставление фильтра при перезагрузке
             */
            resolveQueryFilter() {
                this.filter       = Object.assign({}, this.filterDefault)
				this.customFilter = Object.assign({}, this.customFilterDefault)

				if (this.$route.query && this.$route.query.filter)
					this.filter = Object.assign({}, JSON.parse(this.$route.query.filter))
				
				if (this.$route.query && this.$route.query.custom_filter)
					this.customFilter = JSON.parse(this.$route.query.custom_filter);
            },
			/**
			 * Переключение выпадашки
			 */
			toggleFilter() {
				this.filterSettings = !this.filterSettings;
			},
			/**
			 * Закрытие выпадашки
			 */
			hideFilterSettings() {
				this.filterSettings = false;
			},
			/**
			 * Сброс фильтра
			 */
			onReset() {
				this.filter = Object.assign({}, this.filterDefault)
				this.resetCustomFilter();0
			},
			/**
			 * Кастомный фильтр
			 */
			onCustomFilter() {
				this.filterSettings = false;
				const query = Object.assign({}, this.$route.query);
				query.custom_filter = JSON.stringify(this.customFilter);

				this.$router.push({ name: this.$route.name, params: this.$route.params, query: query });
				this.$root.$emit('refresh-table', 'documents');
			},
			/**
			 * Сброс кастомного фильтра
			 */
			resetCustomFilter() {
				this.customFilter = this.customFilterDefault
				this.$router.push({ name: this.$route.name, params: this.$route.params, query: {}});
				this.$root.$emit('refresh-table', 'documents');  
			},
			/**
			 * Фильтрация
			 */
			async onFilter() {
				const query = Object.assign({}, this.$route.query);

				// Следующее извращение нужно т.к. документ напрямую не связан с грузом, а номер трекинга хранится именно в грузе
				// поэтому если пользователь ввёл номер трекинга, то надо получить список заявок с этим номером,
				// а потом уже фильтровать документы по этому списку
				// в else - просто фильтруем по номеру т.к. если в строке нет дефиса - значит, это не номер трекинга
				if (this.filter.search && (this.filter.search.indexOf('-')+1)) {
					this.filter.deal_id = null
					const deals = await this.getDealsBySearch(this.filter.search)
					if (deals.length) {
						this.filter.number  = null;
						this.filter.deal_id = deals.map(deal => deal.id);
					} else this.filter.number = this.filter.search;
				} else {
					this.filter.deal_id = null;
					this.filter.number = this.filter.search;
				}

				query.filter = JSON.stringify(this.filter);	

				this.$router.push({ name: this.$route.name, params: this.$route.params, query: query });
				this.$root.$emit('refresh-table', 'documents');
			},
			/**
			 * Поиск подходящих под строку запроса заявок
			 * @param {string} search - Строка поиска
			 */
			getDealsBySearch(search) {
				return this.$store.dispatch('deals/getDeals', {
                    count: 10, page: 1, filter: {relation: [['firstFreight', 'traking_number', '%', search]]}
                });
			}
		}
	}
</script>


// WEBPACK FOOTER //
// DocumentsToolbar.vue?bfbd34fa